import { authenticatedApi } from "./client"
import { QuestionAnswer } from "./quests"

export const answerQuestions = async (
  circleId: string,
  answers: QuestionAnswer[],
) => {
  try {
    await authenticatedApi.patch(`/circle/${circleId}/questions`, {
      answers,
    })
  } catch (error) {
    console.error("Error answering questions", error)
    throw error
  }
}
